import { Getters } from 'vuex-smart-module';
import { PurchaseOrders } from '../types';
import PurchaseOrdersState from './state';

export default class PurchaseOrdersGetters extends Getters<PurchaseOrdersState> {
  get purchaseOrders() {
    return this.state.purchase_orders;
  }

  get purchaseOrder() {
    return this.state.purchase_order;
  }

  get totalItems() {
    return this.state.pagination_props.total_items;
  }

  get tableOptions() {
    return this.state.table_options;
  }

  get loading() {
    return this.state.loading;
  }

  get purchaseOrdersLink() {
    return { name: PurchaseOrders.Pages.PURCHASE_ORDER };
  }
}
